import { render } from "./GroupPopoverOptions.vue?vue&type=template&id=2ac77566"
import script from "./GroupPopoverOptions.vue?vue&type=script&lang=js"
export * from "./GroupPopoverOptions.vue?vue&type=script&lang=js"
script.render = render

export default script